import React from 'react';
import styled from 'styled-components';
import TrueImpactModal, {
  modelExtraRadiusStyles,
} from 'shared/design-system/components/TrueImpactModal';
import TrueImpactIconButton from 'shared/design-system/components/TrueImpactIconButton';
import { allFeedbackSectionsWithAllocations } from 'npo/pages/NPOFeedback/utils';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { GuidanceQuestions } from './GuidanceContent';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { AllNpoReportQuestions } from './api';
import { disabledQuestions, getQuestionText } from './disabledQuestions';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import { CustomQuestionSectionId } from '../CustomQuestions/utilts';

interface QuestionsModalProps {
  open: boolean;
  forceAllowQuestionIds: number[];
  disableOtherSections?: boolean;
  defaultExpandedSectionId?: CustomQuestionSectionId;
  questions: GuidanceQuestions | undefined;
  handleClose: () => unknown;
  handleAddQuestion: (
    q: AllNpoReportQuestions['allNpoReportQuestions'][number],
  ) => unknown;
}

const StyledDiv = styled.div`
  .question-add-wrapper {
    display: flex;
    align-items: center;
    gap: ${SPACERS.small};
    padding-top: ${SPACERS.extraTiny};
    padding-bottom: ${SPACERS.extraTiny};
  }
  .MuiAccordionDetails-root {
    display: block;
    padding: ${SPACERS.large};
  }
  .MuiAccordionSummary-root {
    padding-top: ${SPACERS.extraTiny};
    padding-bottom: ${SPACERS.extraTiny};
    background-color: ${COLORS.ctaPrimaryBackground};
  }
`;

const QuestionsModal: React.FC<QuestionsModalProps> = ({
  open,
  questions,
  forceAllowQuestionIds,
  disableOtherSections,
  defaultExpandedSectionId,
  handleClose,
  handleAddQuestion,
}) => {
  return (
    <TrueImpactModal
      open={open}
      hideFooter={true}
      maxWidth="1200px"
      showExpandButton={true}
      onClose={handleClose}
      addStyles={modelExtraRadiusStyles}
    >
      {questions ? (
        <StyledDiv>
          {allFeedbackSectionsWithAllocations.map(x => {
            return (
              <Accordion
                key={x.sectionId}
                disabled={
                  x.sectionId === defaultExpandedSectionId
                    ? false
                    : disableOtherSections
                }
                defaultExpanded={x.sectionId === defaultExpandedSectionId}
              >
                <AccordionSummary
                  id={x.sectionId}
                  aria-controls={x.label}
                  expandIcon={<ExpandMoreIcon />}
                >
                  {x.label}
                </AccordionSummary>
                <AccordionDetails>
                  {questions[x.sectionId].map(q => {
                    if (
                      disabledQuestions[x.sectionId][q.dbId] &&
                      !forceAllowQuestionIds.includes(q.dbId)
                    ) {
                      return null;
                    }
                    return (
                      <div key={q.dbId} className="question-add-wrapper">
                        <TrueImpactIconButton
                          icon={faPlus}
                          backgroundColor="ctaPrimaryBackground"
                          onClick={() => handleAddQuestion(q)}
                        />
                        <strong>{q.dbId}</strong>{' '}
                        {getQuestionText(q.dbId, q.text)}
                      </div>
                    );
                  })}
                </AccordionDetails>
              </Accordion>
            );
          })}
        </StyledDiv>
      ) : (
        <TrueImpactLoading />
      )}
    </TrueImpactModal>
  );
};

export default QuestionsModal;
